import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { clearFileUrls } from '../features/fileUrlsSlice';
import PopupWithForm from "./PopupWithForm";

export default function AddBulkPopup({ isOpen, onClose, onAdd, userId }) {
  const [fileList, setFileList] = useState("");
  const fileUrls = useSelector((state) => state.fileUrls.fileUrls);
  const dispatch = useDispatch();
  const [isClassPhoto, setIsClassPhoto] = useState(false);

  function handleSubmit(evt) {
    evt.preventDefault();
    console.log("[AddBulkPopup] handleSubmit, fileList:", fileList);
    const urls = fileList.split("\n").filter((url) => url.trim() !== "");
    const fileObjects = urls.map((url) => {
      const filename = url.substring(url.lastIndexOf("/") + 1);
      const fileObj = {
        name: filename,
        link: url,
        isClassPhoto: isClassPhoto,
        userId: userId ?? null, // всегда добавляем поле userId
      };
      return fileObj;
    });
    console.log("[AddBulkPopup] handleSubmit, fileObjects:", fileObjects);
    fileObjects.forEach((file) => {
      onAdd(file);
    });
    if (onClose) onClose();
  }

  useEffect(() => {
    if (!isOpen) {
      setFileList("");
      return;
    }

    if (fileUrls) {
      setFileList(fileUrls);
      dispatch(clearFileUrls());
    }
  }, [isOpen, fileUrls, dispatch]);

  return (
    <PopupWithForm
      name="place"
      title="Add new photo"
      onSubmit={handleSubmit}
      onClose={onClose}
      isOpen={isOpen}
      buttonText="Create"
    >
      <textarea
        className="popup__input popup__input_field_link"
        id="input-link"
        name="link"
        placeholder="Enter file URLs (one per line)"
        required
        value={fileList}
        onChange={(evt) => {
          console.log("[AddBulkPopup] Textarea changed:", evt.target.value);
          setFileList(evt.target.value);
        }}
      />
      <span className="popup__error" id="input-link-error"></span>
      <div className="popup__wrapper">
        <label className="popup__label" htmlFor="input-isClassPhoto">
          Is it a class photo?
        </label>
        <input
          className="popup__input_field_checkbox"
          id="input-isClassPhoto"
          type="checkbox"
          name="isClassPhoto"
          checked={isClassPhoto}
          onChange={(evt) => setIsClassPhoto(evt.target.checked)}
        />
      </div>
    </PopupWithForm>
  );
}

